export default __webpack_public_path__ + "static/media/nanny3.dcbcadfa.jpg";